import { createSelector } from '@reduxjs/toolkit';

import { selectDispatchQueryArgs } from './common/selectDispatchQueryArgs';
import type { RootState } from 'src/app/store/types';
import { bambiApi } from 'src/common/external/bambi-api/bambiApi';
import type { DispatchRead } from 'src/common/external/bambi-api/bambiApi';

// endpoints.*.select(args) builds a new memoized selector each call, so cache
// it per args instead of rebuilding it for every consumer on every store
// update.
const selectDispatchCacheEntry = createSelector(
  [selectDispatchQueryArgs],
  (args) => bambiApi.endpoints.dispatchRetrieve.select(args)
);

/**
 * Single read choke point for the dispatch board, backed by the RTK Query
 * cache entry for the app's own query args — optimistic `updateQueryData`
 * patches and reconcile refetches both land where this reads.
 */
export const selectEffectiveDispatchResponse = (
  state: RootState
): DispatchRead | undefined => selectDispatchCacheEntry(state)(state).data;
